<template>
  <div class="container">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <form @submit.prevent="logout">
        <card class="card card-white">
          <template slot="header">
            <img src="img/card-primary.png" alt="" />
          </template>

          <div>
            <h1 class="card-title text-muted">{{ $t('logout.title') }}</h1>
            {{ $t('logout.progressMessage') }}
          </div>

          <base-alert v-if="error" type="danger">
            {{ error }}
          </base-alert>

<!--          <div slot="footer">-->
<!--            <div class="pull-right">-->
<!--              <h6><a href="#" class="link footer-link"> {{ $t('login.helpLinkText') }}</a></h6>-->
<!--            </div>-->
<!--          </div>-->
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import {BaseAlert} from 'src/components'

export default {
  components: {
    BaseAlert
  },
  data() {
    return {
      error: null
    };
  },
  mounted() {
    this.logout()
  },
  methods: {
    logout() {
      this.$auth.logout({
        makeRequest: true,
        // redirect: { name: 'Login' },
        // success () {
        //   this.$router.push({ name: 'Login' })
        // },
        // error (error) {
        //   if (error.status === 401) {
        //     // ok
        //     this.$router.push({ name: 'Login' })
        //   } else {
        //     this.error = error
        //   }
        // }
      })
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
